import { Spin, BackTop } from 'antd';
import classNames from 'classnames';
import parse from 'html-react-parser';
import months from '../months.json';
import useQuery from '../../../../util/useQuery';

export default function PreviewArticle({ lang, detail, mode, loading, logo }) {
    const params = useQuery();
    const hrPrivacyPolicy = detail?.hrPrivacyPolicy;
    const hrIntroductionLawfulBasis = detail?.hrIntroductionLawfulBasis;
    const hrPersonalDataCollect = detail?.hrPersonalDataCollect;
    const hrReasonCollectedData = detail?.hrReasonCollectedData;
    const hrTransferPersonalData = detail?.hrTransferPersonalData;
    const hrRetainPersonalData = detail?.hrRetainPersonalData;
    const hrDataSubjectRight = detail?.hrDataSubjectRight;
    const hrPolicyChange = detail?.hrPolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {hrPrivacyPolicy?.hrCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'TH'
                                                ? hrPrivacyPolicy?.hrCompanyNameTh
                                                : hrPrivacyPolicy?.hrCompanyNameEn
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'TH'
                                        ? hrPrivacyPolicy?.hrPrivacyPolicyNameTh
                                        : hrPrivacyPolicy?.hrPrivacyPolicyNameEn}
                                </h3>
                                <p className="text-left">
                                    {hrIntroductionLawfulBasis?.hrIntroductionIsDisplay ===
                                    true ? (
                                        lang === 'TH' ? (
                                            parse(
                                                hrIntroductionLawfulBasis?.hrIntroductionContentTh ||
                                                    '-'
                                            )
                                        ) : (
                                            parse(
                                                hrIntroductionLawfulBasis?.hrIntroductionContentEn ||
                                                    '-'
                                            )
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </p>
                            </div>
                            <h4>
                                {hrIntroductionLawfulBasis?.hrLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrIntroductionLawfulBasis?.hrLawfulBasisTitleTh
                                    ) : (
                                        hrIntroductionLawfulBasis?.hrLawfulBasisTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrIntroductionLawfulBasis?.hrLawfulBasisIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrIntroductionLawfulBasis?.hrLawfulBasisContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrIntroductionLawfulBasis?.hrLawfulBasisContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrPersonalDataCollect?.hrPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrPersonalDataCollect?.hrPersonalDataTitleTh
                                    ) : (
                                        hrPersonalDataCollect?.hrPersonalDataTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrPersonalDataCollect?.hrPersonalDataIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrPersonalDataCollect?.hrPersonalDataContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrPersonalDataCollect?.hrPersonalDataContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrPersonalDataCollect?.hrSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrPersonalDataCollect?.hrSourceTitleTh
                                    ) : (
                                        hrPersonalDataCollect?.hrSourceTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrPersonalDataCollect?.hrSourceIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrPersonalDataCollect?.hrSourceContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrPersonalDataCollect?.hrSourceContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrReasonCollectedData?.hrPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrReasonCollectedData?.hrPurposeTitleTh
                                    ) : (
                                        hrReasonCollectedData?.hrPurposeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrReasonCollectedData?.hrPurposeIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrReasonCollectedData?.hrPurposeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrReasonCollectedData?.hrPurposeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrTransferPersonalData?.hrDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrTransferPersonalData?.hrDisclosureTitleTh
                                    ) : (
                                        hrTransferPersonalData?.hrDisclosureTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrTransferPersonalData?.hrDisclosureIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrTransferPersonalData?.hrDisclosureContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrTransferPersonalData?.hrDisclosureContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrTransferPersonalData?.hrInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrTransferPersonalData?.hrInternationalTitleTh
                                    ) : (
                                        hrTransferPersonalData?.hrInternationalTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrTransferPersonalData?.hrInternationalIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrTransferPersonalData?.hrInternationalContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrTransferPersonalData?.hrInternationalContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrRetainPersonalData?.hrRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrRetainPersonalData?.hrRetentionTitleTh
                                    ) : (
                                        hrRetainPersonalData?.hrRetentionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrRetainPersonalData?.hrRetentionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrRetainPersonalData?.hrRetentionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrRetainPersonalData?.hrRetentionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrRetainPersonalData?.hrSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrRetainPersonalData?.hrSecurityTitleTh
                                    ) : (
                                        hrRetainPersonalData?.hrSecurityTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrRetainPersonalData?.hrSecurityIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrRetainPersonalData?.hrSecurityContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrRetainPersonalData?.hrSecurityContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrDataSubjectRight?.hrDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrDataSubjectRight?.hrDataSubjectRightTitleTh
                                    ) : (
                                        hrDataSubjectRight?.hrDataSubjectRightTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrDataSubjectRight?.hrDataSubjectRightIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrDataSubjectRight?.hrDataSubjectRightContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrDataSubjectRight?.hrDataSubjectRightContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrPolicyChange?.hrChangeIsDisplay === true ? (
                                    lang === 'TH' ? (
                                        hrPolicyChange?.hrChangeTitleTh
                                    ) : (
                                        hrPolicyChange?.hrChangeTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrPolicyChange?.hrChangeIsDisplay === true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrPolicyChange?.hrChangeContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrPolicyChange?.hrChangeContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrPolicyChange?.hrDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrPolicyChange?.hrDataControllerTitleTh
                                    ) : (
                                        hrPolicyChange?.hrDataControllerTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrPolicyChange?.hrDataControllerIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrPolicyChange?.hrDataControllerContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrPolicyChange?.hrDataControllerContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {hrPolicyChange?.hrDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        hrPolicyChange?.hrDataProtectionTitleTh
                                    ) : (
                                        hrPolicyChange?.hrDataProtectionTitleEn
                                    )
                                ) : (
                                    <></>
                                )}
                            </h4>
                            <p className="indent-8 text-left">
                                {hrPolicyChange?.hrDataProtectionIsDisplay ===
                                true ? (
                                    lang === 'TH' ? (
                                        parse(
                                            hrPolicyChange?.hrDataProtectionContentTh ||
                                                '-'
                                        )
                                    ) : (
                                        parse(
                                            hrPolicyChange?.hrDataProtectionContentEn ||
                                                '-'
                                        )
                                    )
                                ) : (
                                    <></>
                                )}
                            </p>
                            <h4>
                                {lang === 'TH'
                                    ? 'ฉบับ ณ วันที่'
                                    : 'Edition as of'}{' '}
                                {getCurrentDate(hrPrivacyPolicy?.effectiveDate)}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
            <div hidden={!mode}>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center !bg-[#1890ff]"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </Spin>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
